/**
 * @file Configuration for PBF Field Mode
 */

export const config = {
  supabase: {
    url: 'https://tfeduoyqovfzitgrcnhp.supabase.co',
    anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRmZWR1b3lxb3Zmeml0Z3JjbmhwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc1ODM3OTUsImV4cCI6MjA5MzE1OTc5NX0.DZ6Sf10mki6r-geVWB2DNV2gSq9FLi9qrYfS6uEsOF4',
  },
  edgeFunctions: {
    googleAuth: 'https://tfeduoyqovfzitgrcnhp.supabase.co/functions/v1/google-auth',
    stripeInvoice: 'https://tfeduoyqovfzitgrcnhp.supabase.co/functions/v1/stripe-invoice',
  },
  app: {
    name: 'PBF Field Mode',
    version: '1.0.0',
  },
};

export default config;
